import styles from './SigningIframe.scss';
import { Component } from 'react';
import PropTypes from 'prop-types';
import querystring from 'querystring';

function getLocationParams(location){
    const rawQueryString = location.search || '';
    const qs = rawQueryString.replace('?', '');
    const queryStringObject = querystring.parse(qs);

    return queryStringObject;
}

function listenForCredentials(iframe, resolve, reject){
    if(!resolve){
        return new Promise((resolve, reject) => {
            listenForCredentials(iframe, resolve, reject);
        });
    }
    else {
        let creds;

        try {
            if (iframe.contentWindow) {
                creds = getLocationParams(iframe.contentWindow.location);
            }
        }
        catch(e){
            // We are ignoring this exception as there will be a CORS exception as well as other browser related errors
            // until the iframe has been properly setup.
        }


        if(creds && creds.token){
            resolve(creds.token);
        }
        else{
            setTimeout(() => {
                listenForCredentials(iframe, resolve, reject);
            }, 100);
        }
    }
}

export class SigningIframe extends Component {
    componentDidMount(){
        const { login } = this.refs;
        listenForCredentials(login).then(token => {
            this.props.signDocument(token);
        });

        /* 
        ST-27 i-frame not displaying to users intermittently
        https://complion.atlassian.net/browse/ST-27
        Chromium Bugs Board
        https://bugs.chromium.org/p/chromium/issues/detail?id=1153652#c4
        This workaround will force the iframe to re-render after component mounted. 
        */
        login.onload = function (){
            login.style.display = 'none';
            setTimeout(() => {
                login.style.display = 'block';
            }, 200);
        };
    }

    render(){
        const {url, width='500', height='550'} = this.props;
        const style = this.props.className || styles.wrapper;
        return (
            <div className={style} data-cy="SigningIframe">
                <iframe ref="login" src={url} width={width} height={height} />
            </div>
        );
    }
}

SigningIframe.propTypes = {
    url: PropTypes.string.isRequired,
    signDocument: PropTypes.func.isRequired
};
